import React from "react";
import ReactDOM from "react-dom/client";
import "@fontsource/anton";
import "@fontsource/oswald";
import "@fontsource/manrope";
import "@fontsource/jetbrains-mono";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
